import { EventViewDto } from "./../../../../common/data/service-proxies/api";
export const getEventGraphHeight = (dutyStatus: string) => {
  switch (dutyStatus) {
    case "ChangeToOffDutyStatus":
    case "DriverIndicationAuthorizedPersonalUseCmv":
    case "ChangeToOffDutyStatus-E":
    case "DriverIndicationAuthorizedPersonalUseCmv-E":
      return 75;
    case "ChangeToOnDutyNotDrivingStatus":
    case "DriverIndicationYardMoves":
    case "ChangeToOnDutyNotDrivingStatus-E":
    case "DriverIndicationYardMoves-E":
      return 195;
    case "ChangeToDrivingStatus":
    case "ChangeToDrivingStatus-E":
      return 155;
    case "ChangeToSleeperBerthStatus":
    case "ChangeToSleeperBerthStatus-E":
      return 115;
    default:
      return null;
  }
};

export const getPreviousDutyStatus = (
  basicEvents: Array<Partial<EventViewDto>>,
  index: number
) => {
  while (index > 0) {
    const previous = basicEvents[index - 1];
    if (previous.dutyStatus?.endsWith("-CR") !== true) {
      return previous.dutyStatus;
    }

    index--;
  }
};
